import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import React from "react";
import {
  StyleProp,
  StyleSheet,
  Text,
  TextInput,
  View,
  ViewStyle,
  type TextInputProps,
} from "react-native";

export type InputProps = TextInputProps & {
  label?: string;
  lightColor?: string;
  darkColor?: string;
  required?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  disabled?: boolean;
  error?: string;
};

export function Input({
  label,
  style,
  lightColor,
  darkColor,
  required,
  containerStyle,
  disabled,
  error,
  ...rest
}: InputProps) {
  const backgroundColor = "#F3F7F3";
  const textColor = "#011014";
  const borderColor = error ? Colors.error : Colors.border;

  return (
    <View style={[styles.container, containerStyle]}>
      {label && (
        <Text style={[styles.label, { color: textColor }]}>
          {label} {required && <Text style={styles.required}>*</Text>}
        </Text>
      )}
      <TextInput
        style={[
          styles.input,
          disabled ? styles.inputDisabled : styles.inputEnabled,
          { backgroundColor, borderColor },
          style,
        ]}
        placeholderTextColor={"#00000050"}
        editable={!disabled}
        {...rest}
      />
      {error && <Text style={styles.error}>{error}</Text>}
    </View>
  );
}

export default Input;

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  label: {
    fontSize: 13,
    fontFamily: FontFamilies.InterTight.Regular,
    marginBottom: 8,
  },
  input: {
    height: 61,
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    fontSize: 16,
    textAlignVertical: "center",
  },
  inputEnabled: {
    color: "#011014",
  },
  inputDisabled: {
    color: "#01101450",
  },
  required: {
    color: Colors.error,
  },
  error: {
    color: Colors.error,
    fontSize: 12,
    marginTop: 4,
    fontFamily: FontFamilies.InterTight.Regular,
  },
});
